import { Key } from 'lucide-react';

import { EmptyResult } from '@/components/empty-result';

import { emit } from '@/hooks/use-event-handler';

type Props = {
  hasQuery?: boolean;
  handleClearQuery: () => void;
};

export const ApiKeyEmptyResult = ({ hasQuery, handleClearQuery }: Props) => (
  <EmptyResult
    icon={<Key className="h-12 w-12 text-muted-foreground/40" />}
    title={hasQuery ? 'No api keys found for the selected search criteria' : 'No api keys found'}
    description={
      hasQuery
        ? 'Adjust or clear filters to view available api keys.'
        : 'Get started by creating your first api key'
    }
    hasQuery={hasQuery}
    onClear={handleClearQuery}
    onCreate={() => emit('key:create')}
    createButtonText="Create an api key"
  />
);
